import Page from '../../containers/page/page.js';
import React, {Component} from 'react';
import type {TranslateType, ReduxStatusType} from '../../types.js';
import styles from '../Resources/Resources.module.css';
import stylesC from "../Courses/Courses.module.css";
import { Link } from "react-router-dom";
import translate from '../../config/text';


type PropsType = {
    status: ReduxStatusType
};

const Introduction = (props) => {
    return (
        <div className={`${stylesC.coursesPresentation} ${styles.coursesPresentation}`}>
            <p className={`${stylesC.welcomeText} ${styles.welcomeText} fontTisa`}>{props.title}</p>
        </div>
    )
}

const ResourcesWrapper = (props) => {
    return (
        <div className={styles.resourcesWrapper}>
            {props.data.map(resource => {
                return (
                    <div className={styles.singleResource}>
                        <Link
                            key={resource.id}
                            to={`/resource/${resource.id}`}
                        >
                            <h3 className={styles.singleResourceHeader} key={resource.id}>{resource.title}</h3>
                        </Link>
                        {
                            resource.tags ? <div className={styles.tagWrapper}>
                                {
                                    resource.tags.map(tag => {
                                        return <div className={styles.singleTag}><a className={styles.tagLink} key={tag.tid}>{tag.title}</a></div>})
                                }
                            </div> : null
                        }

                        <div className={styles.resourceTeaser} dangerouslySetInnerHTML={ { __html: resource.body } }></div>
                    </div>
                )
            })}
        </div>
    )
}


export class Tags extends Component<PropsType> {
    t: TranslateType
    constructor(props: PropsType) {
        super(props);
        this.state = {
            data: this.props,
        };
        this.t = translate(this.props.language);
    }

    componentDidMount(){
        this.props.fetchDataWithRedux();
    }


    render() {
        const { data } = this.state.data;
        const resourceId = this.props.route.match.params.resourceId;

        let print = data.filter(article =>
            article.terms_combined
                ? article.terms_combined.includes(resourceId)
                : null
        )

        let foo = data.map(i => i.tags ? i.tags.filter(article => article.tid.includes(resourceId)) : null)

        let result = data.filter(article =>
            article.tags
                ? article.tags.some(tag =>
                    tag.tid.includes(resourceId))
                : null);

        console.log(data)
        console.log(this.props)


        return (
                <Page>
                    <Introduction
                        title={resourceId}
                    />
                    <ResourcesWrapper
                        data={print}
                    />
                </Page>
            )
        }
    }





// WEBPACK FOOTER //
// ./src/components/Tags/Tags.js